import React from 'react';
import { Button } from '@ui-propulsion/react-components';
import classNames from 'classnames';

const ActionArea = (props) => {
  const {
    onSubmit,
    disabled,
    isInReview,
    history,
    actions,
    buttonActionText,
    className
  } = props;

  const handleCancel = () => {
    actions.getApplication()
      .then(() => {
        history.push('/patientsolutions/enroll/review');
      })
      .catch(console.log);
  };

  return <div className='action-area'>
    {
      isInReview
        ? <div>
            <Button
              data-test-id="save-button"
              disabled={disabled}
              className={classNames('button-save', { 'disabled': disabled })}
              onClick={onSubmit}>Save</Button>
            <Button onClick={handleCancel} className='button-cancel'>Cancel</Button>
        </div>
        : <Button
          data-test-id={`${buttonActionText.toLowerCase().replaceAll(" ", "-")}-button`}
          onClick={onSubmit}
          className={classNames('button-submit', className, { 'disabled': disabled })}
          disabled={disabled}
          aria-label='practice submit button'>
          <span className='button-submit-text'>{buttonActionText}</span>
        </Button>
    }
    </div>;
};

ActionArea.defaultProps = {
  disabled: false,
  buttonActionText: 'Next'
};

export default ActionArea;

